import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const Contact = ({ slice }) => {
  return (
    <section className='component-contact mx-auto max-w-screen-xl p-6'>
      <div className='relative mx-auto max-w-7xl lg:grid lg:grid-cols-5'>
        {slice.primary.text.html && (
          <div className='max-w-screen-2xl prose prose-xl prose-orange col-span-2 lg:px-5'>
            <PrismicRichText field={slice.primary.text.richText} />
          </div>
        )}
        <div className='col-span-3 lg:border-l-2 lg:px-10'>
          <form name='contact' method='POST' action='/success' data-netlify='true' data-netlify-honeypot='bot-field'>
            <input type='hidden' name='bot-field' />
            <input type='hidden' name='form-name' value='contact' />
            <div className='mb-4'>
              <label className='mt-5 mb-3 block text-xl font-semibold tracking-tighter text-gray-900' htmlFor='name'>
                What's your name?
              </label>
              <input className='w-full appearance-none rounded border py-4 px-5 leading-tight text-gray-700 shadow' type='text' name='name' id='name' required />
            </div>
            <div className='mb-4'>
              <label className='mt-5 mb-3 block text-xl font-semibold tracking-tighter text-gray-900' htmlFor='email'>
                What's your email address?
              </label>
              <input className='w-full appearance-none rounded border py-4 px-5 leading-tight text-gray-700 shadow' type='email' name='email' id='email' required />
            </div>
            <div className='mb-4'>
              <label className='mt-5 mb-3 block text-xl font-semibold tracking-tighter text-gray-900' htmlFor='phone'>
                What's your phone number?
              </label>
              <input className='w-full appearance-none rounded border py-4 px-5 leading-tight text-gray-700 placeholder-gray-500 shadow' type='tel' name='phone' id='phone' placeholder='Optional' />
            </div>
            <div className='mb-4'>
              <label className='mt-5 mb-3 block text-xl font-semibold tracking-tighter text-gray-900' htmlFor='message'>
                How can we help?
              </label>
              <textarea rows='4' className='w-full appearance-none rounded border py-4 px-5 leading-tight text-gray-700 shadow' name='message' id='message' required></textarea>
            </div>
            <div className='mb-4 block transform rounded-lg text-white shadow transition duration-150 ease-linear hover:-translate-y-1 hover:shadow-md sm:inline-block'>
              <button type='submit' className='button w-full sm:w-auto'>
                Send your enquiry
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
